import React, {useEffect, useState, useMemo, useCallback, useRef} from 'react';
import {Card, Container, FormGroup, Label, Input} from 'reactstrap';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
} from '../../../components/Component';
import {GiHamburgerMenu} from 'react-icons/gi';
import {useDrag, useDrop} from 'react-dnd';
import classnames from 'classnames';
import Content from '../../../layout/content/Content';
import {Row, Col, Table, Modal} from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Head from '../../../layout/head/Head';
import {nanoid} from 'nanoid';
import {SellerFilesTest} from './SellerFilesTest';
import ExcelGrid from '../../../components/excel/excelGrid';
import CustomSelect from '../../followUp/Components/customselect';
import excelIntegration from './send-data';
import Swal from 'sweetalert2';
import {GetExpoEntities} from '../../followUp/Components/helpers/entities_info';
import {apiKey} from '../../followUp/Components/helpers/keys.helper';
import {BACKEND} from '../../../consts/backend.js';


const macroEditStyles = `
  .macro-edit .panel-card {
    border: 1px solid #e5e9f2;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(91,124,251,0.07);
    background: #fff;
    padding: 20px 24px 16px;
    margin-bottom: 16px;
  }
  .macro-edit .section-title {
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #5e72e4;
    margin-bottom: 12px;
  }
  .macro-edit .hint-text {
    font-size: 12px;
    color: #8898aa;
    background: linear-gradient(135deg, rgba(17,205,239,0.08) 0%, rgba(94,114,228,0.06) 100%);
    border-left: 3px solid #5e72e4;
    border-radius: 0 6px 6px 0;
    padding: 6px 12px;
    margin-bottom: 12px;
    display: inline-block;
    width: 100%;
  }
  .macro-edit .table-platform thead th {
    background: #f5f6fa;
    color: #526484;
    border-bottom: 2px solid #e5e9f2;
    font-weight: 700;
    font-size: 12px;
    padding: 8px 10px;
  }
  .macro-edit .table-platform {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    margin-bottom: 0;
  }
  .macro-edit .table-platform tbody tr:nth-child(even) {
    background-color: #f8f9ff;
  }
  .macro-edit .table-platform tbody tr:hover {
    background: rgba(94,114,228,0.06);
  }
  .macro-edit .table-platform td {
    padding: 4px 6px;
    vertical-align: middle;
  }
  .macro-edit .table-platform .form-control-sm {
    border: 1px solid #e5e9f2;
    border-radius: 6px;
    font-size: 12px;
    height: 28px;
    transition: border-color 0.2s;
  }
  .macro-edit .table-platform .form-control-sm:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.15rem rgba(102,126,234,0.2);
  }
  .macro-edit .scroll-table {
    border-radius: 8px;
    overflow: auto;
  }
  .macro-edit .btn-macro-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 7px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 14px;
    transition: all 0.2s ease;
  }
  .macro-edit .btn-macro-primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(102,126,234,0.3);
    color: #fff;
  }
  .macro-edit .btn-macro-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
  .macro-edit .btn-macro-outline {
    background: transparent;
    border: 1.5px solid #5e72e4;
    border-radius: 7px;
    color: #5e72e4;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 14px;
    transition: all 0.2s ease;
  }
  .macro-edit .btn-macro-outline:hover {
    background: rgba(94,114,228,0.08);
    transform: translateY(-1px);
  }
  .macro-edit .btn-macro-danger {
    background: transparent;
    border: 1.5px solid #f56565;
    border-radius: 7px;
    color: #f56565;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 14px;
    transition: all 0.2s ease;
  }
  .macro-edit .btn-macro-danger:hover {
    background: rgba(245,101,101,0.08);
    transform: translateY(-1px);
  }
  .macro-edit .spinner-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #8898aa;
    font-size: 13px;
  }
`;

if (!document.getElementById('macro-edit-styles')) {
  const el = document.createElement('style');
  el.id = 'macro-edit-styles';
  el.textContent = macroEditStyles;
  document.head.appendChild(el);
}
const AVAILABLE_STATE = 'available';
const SELECTED_STATE = 'selected';

// Componente de autocompletado simple (mismo estilo que gestor_315)
const SimpleAutocomplete = ({ name, placeholder, options, value, onChange, disabled = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (value.trim() === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
    setSelectedIndex(-1);
  }, [value, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectOption = (option) => {
    onChange(option);
    setShowDropdown(false);
    setSelectedIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (disabled) return;
    
    if (!showDropdown || filteredOptions.length === 0) {
      if (e.key === 'ArrowDown') {
        setShowDropdown(true);
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < filteredOptions.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => prev > 0 ? prev - 1 : 0);
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && selectedIndex < filteredOptions.length) {
          handleSelectOption(filteredOptions[selectedIndex]);
        }
        break;
      case 'Escape':
        setShowDropdown(false);
        setSelectedIndex(-1);
        break;
      default:
        break;
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <Input
        type="text"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => !disabled && onChange(e.target.value)}
        onFocus={() => !disabled && setShowDropdown(true)}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        disabled={disabled}
      />

      {showDropdown && filteredOptions.length > 0 && !disabled && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: 'white',
            border: '1px solid #dbdfea',
            borderRadius: '4px',
            marginTop: '4px',
            zIndex: 1000,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          {filteredOptions.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelectOption(option)}
              style={{
                padding: '10px 15px',
                cursor: 'pointer',
                borderBottom: index < filteredOptions.length - 1 ? '1px solid #f5f6fa' : 'none',
                backgroundColor: index === selectedIndex ? '#e3e7fe' : 'transparent'
              }}
              onMouseEnter={() => setSelectedIndex(index)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const DashboardMacroEdit = () => {
  const [atribute, setAtribute] = useState('');
  const [data, setData] = useState([]);
  const [label, setlabel] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);

  // Estados para el modal de entidades
  const [showEntityModal, setShowEntityModal] = useState(false);
  const [entityModalType, setEntityModalType] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [selectedEntityId, setSelectedEntityId] = useState('');
  const [entityOptions, setEntityOptions] = useState([]);
  const [isSavingEntity, setIsSavingEntity] = useState(false);
  const [entityFilter, setEntityFilter] = useState('');
  const [addressFilter, setAddressFilter] = useState('');
  const [availableEntities, setAvailableEntities] = useState([]);
  const [isLoadingEntities, setIsLoadingEntities] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  const isDocumentAtrib = (attr) =>
    attr &&
    attr.label &&
    attr.label.substr(0, 8) === 'Document' &&
    attr.label !== 'Document Packet Sent';

  const statusOptions = [
    { value: 7, label: 'New' },
    { value: 14, label: 'Accepted by FF' },
    { value: 12, label: 'In Transit ' },
    { value: 9, label: 'Arrived' },
    { value: 10, label: 'Canceled' },
  ];

  const getStatusNameFromText = (text) => {
    if (!text) return '';
    const cleanInput = String(text).toUpperCase().replace(/\s+/g, '');
    
    // 1. Try exact match (normalized)
    const exactMatch = statusOptions.find(opt => {
      const cleanLabel = opt.label.toUpperCase().replace(/\s+/g, '');
      return cleanLabel === cleanInput;
    });
    if (exactMatch) return exactMatch.label;

    // 2. Try partial match (like SQL %LIKE% - checking if input is inside label or label inside input)
    const partialMatch = statusOptions.find(opt => {
      const cleanLabel = opt.label.toUpperCase().replace(/\s+/g, '');
      return cleanLabel.includes(cleanInput) || cleanInput.includes(cleanLabel);
    });
    if (partialMatch) return partialMatch.label;

    // If no match found, send input as is
    return text;
  };

  const buildDataFromRows = (rows, attr) =>
    rows
      .filter((r) => String(r.po ?? '').trim() !== '')
      .map((r) => {
        let val = r.value;
        const isNullInput = String(val ?? '').trim() === '00000';
        if (isNullInput) {
          val = '00000';
        } else if (attr.prop === 'sold_to' || attr.prop === 'ship_to' || attr.prop === 'ship_to_&_sold_to') {
          val = selectedEntityId;
        } else if (attr.prop === 'status_id') {
          val = getStatusNameFromText(r.value);
        }

        const payloadData = {
          po: r.po,
          value: val,
          user_name: user?.name,
        };
        if (isDocumentAtrib(attr)) {
          payloadData.date = r.date || '';
        }
        return {
          target: attr.prop,
          data: payloadData,
        };
      });

  const createEmptyRows = (attr, count = 10) => {
    const isDoc = isDocumentAtrib(attr);
    return Array.from({length: count}, () => ({
      po: '',
      value: '',
      ...(isDoc ? {date: ''} : {}),
      original: '',
      originalLoading: false,
    }));
  };

  // Abrir modal de entidad
  const openEntityModal = (type) => {
    setEntityModalType(type);
    setEntityOptions([]);
    setEntityFilter('');
    setShowEntityModal(true);
  };

  // Cerrar modal de entidad
  const closeEntityModal = () => {
    setShowEntityModal(false);
    setEntityModalType(null);
    setEntityOptions([]);
    setEntityFilter('');
  };

  // Obtener identificadores de entidad según el tipo
  const getEntityIdentifiers = (type) => {
    const identifiers = {
      'sold_to': ['BT'],
      'ship_to': ['ST']
    };
    return identifiers[type] || [];
  };

  // Manejar cambio de entidad seleccionada
  const handleEntitySelect = (entityName) => {
    setSelectedEntity(entityName);
    setSelectedEntityId('');
    setEntityFilter(entityName);
    setAddressFilter('');
  };

  // Obtener opciones de entidades únicas para el select
  const getUniqueEntityOptions = () => {
    if (!entityModalType) return [];
    
    if (entityModalType === 'ship_to_&_sold_to') {
      const btEntities = availableEntities.filter(e => e.entityidentifier === 'BT');
      const stEntities = availableEntities.filter(e => e.entityidentifier === 'ST');
      
      // Encontrar nombres que están en ambos grupos
      const btNames = new Set(btEntities.map(e => e.name.toLowerCase()));
      const stNames = new Set(stEntities.map(e => e.name.toLowerCase()));
      const commonNames = [...btNames].filter(name => stNames.has(name));
      
      const uniqueNames = [...new Set(
        availableEntities
          .filter(e => commonNames.includes(e.name.toLowerCase()))
          .map(e => e.name)
      )];
      
      const options = uniqueNames.map(name => ({ name }));
      return options.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      const identifiers = getEntityIdentifiers(entityModalType);
      const filtered = availableEntities.filter(e => identifiers.includes(e.entityidentifier));
      const uniqueNames = [...new Set(filtered.map(e => e.name))];
      const options = uniqueNames.map(name => ({ name }));
      return options.sort((a, b) => a.name.localeCompare(b.name));
    }
  };

  // Obtener opciones de direcciones únicas para la entidad seleccionada
  const getUniqueAddressOptions = () => {
    if (!selectedEntity) return [];
    
    if (entityModalType === 'ship_to_&_sold_to') {
      const btAddresses = availableEntities
        .filter(e => e.name === selectedEntity && e.entityidentifier === 'BT')
        .map(e => (e.address || '').trim().toLowerCase());
        
      const stAddresses = availableEntities
        .filter(e => e.name === selectedEntity && e.entityidentifier === 'ST')
        .map(e => (e.address || '').trim().toLowerCase());
        
      const btAddressSet = new Set(btAddresses);
      const commonAddresses = stAddresses.filter(addr => btAddressSet.has(addr));
      
      const filtered = availableEntities.filter(
        e => e.name === selectedEntity && 
             e.entityidentifier === 'ST' && 
             commonAddresses.includes((e.address || '').trim().toLowerCase())
      );

      const uniqueAddresses = [];
      const seen = new Set();
      for (const item of filtered) {
        const addrKey = (item.address || '').trim().toLowerCase();
        if (!seen.has(addrKey)) {
          seen.add(addrKey);
          uniqueAddresses.push(item);
        }
      }
      
      return uniqueAddresses.sort((a, b) => (a.address || '').localeCompare(b.address || ''));
    } else {
      const identifiers = getEntityIdentifiers(entityModalType);
      const options = availableEntities.filter(
        e => e.name === selectedEntity && identifiers.includes(e.entityidentifier)
      );
      return options.sort((a, b) => (a.address || '').localeCompare(b.address || ''));
    }
  };

  // Cargar entidades disponibles al montar el componente
  useEffect(() => {
    const loadEntities = async () => {
      setIsLoadingEntities(true);
      try {
        const response = await GetExpoEntities();
        if (response && !response.error) {
          setAvailableEntities(response.data || []);
        }
      } catch (error) {
        console.error('Error loading entities:', error);
      } finally {
        setIsLoadingEntities(false);
      }
    };
    loadEntities();
  }, []);

  // Consultar valores originales en base de datos al ingresar o pegar POs
  useEffect(() => {
    if (!atribute) return;
    const isEntityAttr = atribute.prop === 'sold_to' || atribute.prop === 'ship_to' || atribute.prop === 'ship_to_&_sold_to';
    if (!isEntityAttr) return;

    // Buscar POs que necesitan consulta (po no vacía, sin valor original, y no cargando)
    const pendingRows = tableRows.filter(
      (r) => r.po && String(r.po).trim() !== '' && !r.original && !r.originalLoading
    );

    if (pendingRows.length === 0) return;

    const posToFetch = pendingRows.map((r) => String(r.po).trim());
    
    // Determinar tipo según el atributo para el endpoint
    let apiType = '';
    if (atribute.prop === 'sold_to') apiType = 'BT';
    else if (atribute.prop === 'ship_to') apiType = 'ST';
    else if (atribute.prop === 'ship_to_&_sold_to') apiType = 'both';

    // 1. Marcar como cargando en el estado inmediatamente
    setTableRows((prevRows) =>
      prevRows.map((row) => {
        if (row.po && posToFetch.includes(String(row.po).trim())) {
          return { ...row, originalLoading: true };
        }
        return row;
      })
    );

    // 2. Realizar consulta al endpoint
    const fetchOriginalValues = async () => {
      try {
        const response = await fetch(`${BACKEND}/expo/get-original-values`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: apiKey,
          },
          body: JSON.stringify({
            pos: posToFetch,
            type: apiType,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const resData = await response.json();
        const originalMap = resData.data || {};

        // Actualizar filas de la tabla con los valores obtenidos
        setTableRows((prevRows) =>
          prevRows.map((row) => {
            if (row.po && posToFetch.includes(String(row.po).trim())) {
              const poKey = String(row.po).trim();
              return {
                ...row,
                original: originalMap[poKey] || '-',
                originalLoading: false,
              };
            }
            return row;
          })
        );
      } catch (err) {
        console.error('Error fetching original values:', err);
        // Reiniciar estado de carga con indicador de error
        setTableRows((prevRows) =>
          prevRows.map((row) => {
            if (row.po && posToFetch.includes(String(row.po).trim())) {
              return { ...row, originalLoading: false, original: 'Error' };
            }
            return row;
          })
        );
      }
    };

    fetchOriginalValues();
  }, [tableRows, atribute]);

  // Guardar selección de entidad y rellenar tabla
  const saveEntityChanges = () => {
    if (!selectedEntity) return;

    let targetId = selectedEntityId;

    if (entityModalType === 'ship_to_&_sold_to') {
      const stMatch = availableEntities.find(
        e => e.name.trim().toLowerCase() === selectedEntity.trim().toLowerCase() && 
             (e.address || '').trim().toLowerCase() === (addressFilter || '').trim().toLowerCase() && 
             e.entityidentifier === 'ST'
      );
      const btMatch = availableEntities.find(
        e => e.name.trim().toLowerCase() === selectedEntity.trim().toLowerCase() && 
             (e.address || '').trim().toLowerCase() === (addressFilter || '').trim().toLowerCase() && 
             e.entityidentifier === 'BT'
      );
      
      if (!stMatch || !btMatch) {
        Swal.fire({
          title: 'Error',
          text: 'No se encontraron IDs correspondientes para Ship To y Sold To en esa dirección.',
          icon: 'error'
        });
        return;
      }
      targetId = `${stMatch.id}_${btMatch.id}`;
      setSelectedEntityId(targetId);
    } else {
      if (!targetId) {
        const identifiers = getEntityIdentifiers(entityModalType);
        const match = availableEntities.find(
          e => e.name.trim().toLowerCase() === selectedEntity.trim().toLowerCase() && 
               (e.address || '').trim().toLowerCase() === (addressFilter || '').trim().toLowerCase() && 
               identifiers.includes(e.entityidentifier)
        );
        if (match) {
          targetId = match.id;
          setSelectedEntityId(match.id);
        }
      }
      
      if (!targetId) {
        Swal.fire({
          title: 'Error',
          text: 'No se encontró el ID de la entidad seleccionada.',
          icon: 'error'
        });
        return;
      }
    }
    
    const entityLabel = `${selectedEntity}${addressFilter ? ' - ' + addressFilter : ''}`;
    
    const newRows = tableRows.map(row => {
      if (row.po) {
        return { ...row, value: entityLabel };
      }
      return row;
    });
    
    setTableRows(newRows);
    setData(buildDataFromRows(newRows, atribute));
    closeEntityModal();
  };

  const handleUpload = async () => {
    setShowSpinner(true);
    try {
      if (atribute.prop === 'ship_to_&_sold_to') {
        const [stId, btId] = String(selectedEntityId).split('_');
        
        const shipToData = tableRows
          .filter((r) => String(r.po ?? '').trim() !== '')
          .map((r) => ({
            target: 'ship_to',
            data: {
              po: r.po,
              value: String(r.value ?? '').trim() === '00000' ? '00000' : stId,
              user_name: user?.name,
            },
          }));
          
        const soldToData = tableRows
          .filter((r) => String(r.po ?? '').trim() !== '')
          .map((r) => ({
            target: 'sold_to',
            data: {
              po: r.po,
              value: String(r.value ?? '').trim() === '00000' ? '00000' : btId,
              user_name: user?.name,
            },
          }));

        const responseShipTo = await excelIntegration(shipToData);
        if (responseShipTo.data && responseShipTo.data.state) {
          const responseSoldTo = await excelIntegration(soldToData);
          if (responseSoldTo.data && responseSoldTo.data.state) {
            await Swal.fire({title: 'Data uploaded successfully (Ship To & Sold To)', icon: 'success'});
            setData([]);
            setTableRows(createEmptyRows(atribute));
            setSelectedEntity('');
            setSelectedEntityId('');
          } else {
            const is500 = responseSoldTo.status === 500;
            Swal.fire({
              title: is500 ? 'Error' : 'Oops!!',
              text: 'Error in Sold To: ' + (responseSoldTo.error || 'Unknown error occurred'),
              icon: is500 ? 'error' : 'warning'
            });
          }
        } else {
          const is500 = responseShipTo.status === 500;
          Swal.fire({
            title: is500 ? 'Error' : 'Oops!!',
            text: 'Error in Ship To: ' + (responseShipTo.error || 'Unknown error occurred'),
            icon: is500 ? 'error' : 'warning'
          });
        }
      } else {
        const response = await excelIntegration(data);
        if (response.data && response.data.state) {
          await Swal.fire({title: 'Data uploaded successfully', icon: 'success'});
          setData([]);
          setTableRows(createEmptyRows(atribute));
          setSelectedEntity('');
          setSelectedEntityId('');
        } else {
          const is500 = response.status === 500;
          Swal.fire({
            title: is500 ? 'Error' : 'Oops!!',
            text: response.error || 'Unknown error occurred',
            icon: is500 ? 'error' : 'warning'
          });
        }
      }
    } catch (error) {
      Swal.fire({title: 'Oops!!', text: 'An error occurred while submitting the data.', icon: 'error'});
    }
    setShowSpinner(false);
  };

  const handleFileData = (fileData) => {
    setData(fileData);
    setTableRows(
      fileData.map((r) => ({
        po: r.data.po ?? '',
        value: r.data.value ?? '',
        ...(isDocumentAtrib(atribute) ? {date: r.data.date ?? ''} : {}),
        original: '',
        originalLoading: false,
      }))
    );
  };

  const handleRowsChange = (newRows) => {
    let updatedRows = newRows;
    if (atribute && (atribute.prop === 'sold_to' || atribute.prop === 'ship_to' || atribute.prop === 'ship_to_&_sold_to')) {
      const entityLabel = selectedEntity ? `${selectedEntity}${addressFilter ? ' - ' + addressFilter : ''}` : '';
      updatedRows = newRows.map((row, idx) => {
        const oldRow = tableRows[idx];
        const poChanged = oldRow && String(oldRow.po ?? '').trim() !== String(row.po ?? '').trim();
        
        let original = row.original || '';
        let originalLoading = row.originalLoading || false;
        if (poChanged) {
          original = '';
          originalLoading = false;
        }

        if (row.po && String(row.po).trim() !== '') {
          const isNullInput = String(row.value ?? '').trim() === '00000';
          return { ...row, value: isNullInput ? '00000' : (entityLabel || row.value), original, originalLoading };
        }
        return { ...row, original: '', originalLoading: false };
      });
    }
    setTableRows(updatedRows);
    setData(buildDataFromRows(updatedRows, atribute));
  };

  const addRow = () => {
    const isDoc = isDocumentAtrib(atribute);
    const newRows = [...tableRows, {po: '', value: '', ...(isDoc ? {date: ''} : {}), original: '', originalLoading: false}];
    setTableRows(newRows);
  };

  const headersNames = [
    {label: 'Status', prop: 'status_id'},
    {label: 'Order Rush', prop: 'order_rush'},
    // {label: 'Additional', prop: 'remarks_free_form_message'},
    {label: 'container Quantity', prop: 'containers_quantity'},
    {label: 'Currency', prop: 'exchange_rate_currency_code'},
    {label: 'Transport Method', prop: 'transport_mode'},
    {label: 'Incoterm', prop: 'incoterm_id'},
    {label: 'Document Packet Sent', prop: 'document_packet_date'},
    {label: 'Incoterm (Location)', prop: 'incoterm_2'},
    {label: 'Departure', prop: 'departure_port_id'},
    {label: 'Destination', prop: 'destination_port_id'},
    {label: 'ATA (Agente)', prop: 'ata_agent_id'},
    {label: 'Inland Transport', prop: 'inland_trucker'},
    {label: 'Terminal', prop: 'entry_terminal'},
    {label: 'Carrier', prop: 'carriers_leg_id'},
    {label: 'Booking Request', prop: 'delivery_date'},
    {label: 'Booking', prop: 'booking_number'},
    {label: 'Date Booking', prop: 'delivery_to_port_plan_date'},
    {
      label: 'Confirmation Booking',
      prop: 'booking_approval_date',
    },
    {label: 'Documental Cut Off', prop: 'document_cutoff_date'},
    {
      label: 'Physical Cut Off',
      prop: 'cutoff_date_at_departure',
    },
    {
      label: 'Documental Cut Off (IMO)',
      prop: 'documental_cut_off_imo',
    },
    {label: 'VGM Cut Off', prop: 'vgm_cut_off'},
    {label: 'ETD', prop: 'estimated_departure_date'},
    {
      label: 'ATD',
      prop: 'actual_discharge',
    },
    {label: 'ETA', prop: 'estimated_arrival_date'},
    {label: 'ATA', prop: 'actual_arrival_date'},
    {label: 'Vessel', prop: 'expo_vessels_id'},
    {label: 'Voyage', prop: 'flight_voyage_number'},
    // {label: 'Flag', prop: 'flag'},
    {label: 'Customs (Origin)', prop: 'customs_origin_id'},
    {label: 'Customs (Exit)', prop: 'customs_destination_id'},
    {label: 'Permit (Date)', prop: 'permition_date'},
    {label: 'Export Permit', prop: 'per_export'},
    {label: 'Comission', prop: 'commission'},
    {label: 'Linked Company', prop: 'linked_company'},
    {
      label: 'Bank',
      prop: 'bank_id',
    },
    {label: 'Currency (Custom)', prop: 'currency_id'},
    {label: 'Triangulated', prop: 'triangulated'},
    {label: 'Nacionalizated', prop: 'nationalized'},
    {label: 'Temporary Import', prop: 'temporary_import'},
    // {label: 'Payment Term', prop: 'terms_of_sale_description'},
    {
      label: 'Custom Transmission Date',
      prop: 'custom_transmition_date',
    },
    {label: 'Custom Broker', prop: 'customs_broker_id'},
    // {label: 'cuit', prop: 'cuit'},
    {
      label: 'Document Invoice',
      prop: 'invoice',
      extra: 'Document Date',
    },
    //{label: 'Document N° Invoice', prop: 'file_new_name'},
    {
      label: 'Document PackingList',
      prop: 'packing_list',
      extra: 'Document Date',
    },
    //{label: 'Document N° PackingList', prop: 'file_new_name'},
    {
      label: 'Document COO/COD',
      prop: 'COO/COD',
      extra: 'Document Date',
    },
    //{label: 'Document N° COO/COD', prop: 'file_new_name'},
    {
      label: 'Document Export Permit',
      prop: 'export_permit',
      extra: 'Document Date',
    },
    //{label: 'Document N° Export Permit', prop: 'file_new_name'},
    {
      label: 'Document Bill of Lading',
      prop: 'bill_of_landing',
      extra: 'Document Date',
    },
    //{label: 'Document N° Bill of Lading', prop: 'file_new_name'},
    {
      label: 'Document CRT',
      prop: 'CRT',
      extra: 'Document Date',
    },
    //{label: 'Document N° CRT', prop: 'file_new_name'},
    {
      label: 'Document Airwaybill',
      prop: 'airwaybill',
      extra: 'Document Date',
    },
    //{label: 'Document N° Airwaybill', prop: 'file_new_name'},
    {
      label: 'Document Export License',
      prop: 'export_license',
      extra: 'Document Date',
    },
    //{label: 'Document N° Export License', prop: 'file_new_name'},
    {
      label: 'Document MSDS',
      prop: 'MSDS',
      extra: 'Document Date',
    },
    //{label: 'Document N° MSDS', prop: 'file_new_name'},
    {
      label: 'Document COA',
      prop: 'COA',
      extra: 'Document Date',
    },
    {label: 'Sold To', prop: 'sold_to'},
    {label: 'Ship To', prop: 'ship_to'},
    {label: 'Ship To & Sold To', prop: 'ship_to_&_sold_to'},
    //{label: 'Document N° COA', prop: 'file_new_name'},
    // {label: 'First leg mode', prop: 'first_leg_mode_id'},
    // {label: 'First Office Number', prop: 'first_office_number'},
    // {label: 'First Motor Carrier', prop: 'first_motor_carrier'},
    // {label: 'Second leg mode', prop: 'second_leg_mode_id'},
    // {label: 'Second Office Number', prop: 'second_office_number'},
    // {label: 'Second Motor Carrier', prop: 'second_motor_carrier'},
    // {
    //   label: 'Portal Terminal Transpotation',
    //   prop: 'port_terminal_id',
    // },
    // {label: 'Text 501', prop: 'remarks'},
    // {label: 'Text 502', prop: 'text502'}
  ];

  const onChange = (e) => {
    if (e.label.substr(0, 8) === 'Document' && e.label != 'Document Packet Sent') {
      setlabel([e.label, e.extra]);
    } else {
      setlabel([e.label]);
    }
    setAtribute(e);
    setData([]);
    setTableRows(createEmptyRows(e));

    // Reset selection state when attribute changes
    setSelectedEntity('');
    setSelectedEntityId('');
    setAddressFilter('');

    if (e.prop === 'sold_to' || e.prop === 'ship_to' || e.prop === 'ship_to_&_sold_to') {
      openEntityModal(e.prop);
    }
  };
  const options = headersNames.map((header, index) => {
    return {
      prop: header.prop,
      label: header.label,
      index: index,
      isSelected: false,
    };
  });
  const [availableHeadersList, setAvailableHeadersList] =
    useState(options);
  const [{isOver}, addToSelected] = useDrop({
    accept: AVAILABLE_STATE,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const [{isOver: isAvailableOver}, removeFromSelected] = useDrop({
    accept: SELECTED_STATE,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const moveColumns = (itemSelected) => {
    const $availableHeadersList = Object.create(availableHeadersList);
    const itemToReplace = $availableHeadersList.find(
      (option) => option.index === itemSelected.index
    );
    if (itemToReplace) {
      itemToReplace.isSelected = !itemSelected.isSelected;
      $availableHeadersList.splice(
        $availableHeadersList.indexOf(itemToReplace),
        1,
        itemToReplace
      );
      setAvailableHeadersList($availableHeadersList);
    }
  };

  const colKeys = useMemo(() => {
    const base = [{key: 'po', label: 'Po Number'}, {key: 'value', label: label[0] || 'Value'}];
    if (isDocumentAtrib(atribute)) base.push({key: 'date', label: label[1] || 'Document Date'});
    
    const isEntityAttr = atribute && (atribute.prop === 'sold_to' || atribute.prop === 'ship_to' || atribute.prop === 'ship_to_&_sold_to');
    const hasPOs = tableRows.some(row => row.po && String(row.po).trim() !== '');
    if (isEntityAttr && hasPOs) {
      base.push({key: 'original', label: 'Dato Original'});
    }
    return base;
  }, [atribute, label, tableRows]);

  const dragHoverTeamBG = isOver ? 'bg-light' : 'bg-white';
  const dragHoverPlayerBG = isAvailableOver ? 'bg-light' : 'bg-white';
  const isAnyLoading = showSpinner || tableRows.some(row => row.originalLoading);
  return (
    <>
      <Content>
        <Head title="MacroEdit - SSB SYSTEM"></Head>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle className="text-ssbnaranja" tag="h2" page>
                MacroEdit - SSB SYSTEM
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="macro-edit">

            {/* Panel superior: selector + file input */}
            <div className="panel-card">
              <div className="section-title">Select Column to Edit</div>
              <Row>
                <Col lg="6" md="6">
                  <CustomSelect
                    optionsSelect={headersNames}
                    onChange={onChange}
                    value={atribute || null}
                    placeholder="Select a column..."
                    menuPortalTarget={document.body}
                    customStyles={{
                      control: (base, {isFocused}) => ({
                        ...base,
                        borderColor: isFocused ? '#5e72e4' : '#dbdfea',
                        boxShadow: 'none',
                        '&:hover': {borderColor: '#5e72e4'},
                      }),
                      option: (base, {isSelected, isFocused}) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? '#5e72e4'
                          : isFocused
                          ? '#eef0fd'
                          : '#fff',
                        color: isSelected ? '#fff' : '#526484',
                        cursor: 'pointer',
                      }),
                      singleValue: (base) => ({...base, color: '#526484'}),
                      menuPortal: (base) => ({...base, zIndex: 9999}),
                    }}
                  />
                  {atribute && (atribute.prop === 'sold_to' || atribute.prop === 'ship_to' || atribute.prop === 'ship_to_&_sold_to') && !tableRows.some(row => row.po && String(row.po).trim() !== '') && (
                    <div className="mt-3 p-3 border rounded bg-light d-flex align-items-center justify-content-between">
                      <div>
                        <span className="text-muted d-block" style={{ fontSize: '11px', textTransform: 'uppercase', fontWeight: 600 }}>Entidad Seleccionada:</span>
                        <strong style={{ fontSize: '13px', color: '#3c4d6f' }}>
                          {selectedEntity ? `${selectedEntity}${addressFilter ? ' - ' + addressFilter : ''}` : 'Ninguna seleccionada'}
                        </strong>
                        {selectedEntityId && (
                          <span className="badge badge-primary" style={{ fontSize: '10px', backgroundColor: '#5e72e4', color: '#fff', marginLeft: '8px' }}>
                            {atribute.prop === 'ship_to_&_sold_to' && String(selectedEntityId).includes('_') 
                              ? `IDs: ${String(selectedEntityId).replace('_', ' / ')}` 
                              : `ID: ${selectedEntityId}`}
                          </span>
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={() => openEntityModal(atribute.prop)}
                        style={{
                          border: '1.5px solid #5e72e4',
                          color: '#5e72e4',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: 600,
                          padding: '4px 10px',
                          backgroundColor: 'transparent',
                          cursor: 'pointer'
                        }}
                      >
                        Cambiar Entidad
                      </button>
                    </div>
                  )}
                </Col>
                <Col lg="6" md="6">
                  {atribute !== '' ? (
                    <SellerFilesTest
                      setData={handleFileData}
                      data={data}
                      atribute={atribute}
                      hideSubmitButton
                    />
                  ) : null}
                </Col>
              </Row>
            </div>

            {/* Panel tabla editable */}
            {atribute !== '' && (
              <div className="panel-card">
                <div className="section-title">Edit Data</div>
                <div className="hint-text">
                  Pegá datos desde Excel con <strong>Ctrl+V</strong> o editá las celdas manualmente.
                </div>

                {tableRows.some(r => Object.entries(r).some(([k, v]) => k !== 'po' && k !== 'original' && String(v ?? '').trim() === '00000')) && (
                  <div
                    style={{
                      margin: '10px 0 14px 0',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      backgroundColor: '#fffbeb',
                      border: '1px solid #fde68a',
                      color: '#92400e',
                      fontSize: '12.5px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <i className="fas fa-exclamation-triangle" style={{ color: '#d97706', fontSize: '14px' }}></i>
                    <span>
                      <strong>Comando 00000 detectado:</strong> Las celdas resaltadas en amarillo guardarán un valor <strong>NULL</strong> para ese registro en ese campo al subir los datos.
                    </span>
                  </div>
                )}

                <ExcelGrid
                  rows={tableRows}
                  colKeys={colKeys}
                  onChange={handleRowsChange}
                />

                {/* Barra de acciones */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '14px',
                  }}
                >
                  <div style={{display: 'flex', gap: '5px'}}>
                    <button
                      type="button"
                      className="btn-macro-outline"
                      onClick={addRow}
                      disabled={isAnyLoading}
                    >
                      + Add Row
                    </button>
                    <button
                      type="button"
                      className="btn-macro-danger"
                      onClick={() => {
                        setTableRows(createEmptyRows(atribute));
                        setData([]);
                      }}
                      disabled={isAnyLoading}
                    >
                      Clear
                    </button>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    {showSpinner && (
                      <div className="spinner-row">
                        <Spinner animation="border" size="sm" />
                        <span>Processing...</span>
                      </div>
                    )}
                    {data.length > 0 && (
                      <button
                        type="button"
                        className="btn-macro-primary"
                        onClick={handleUpload}
                        disabled={isAnyLoading || ((atribute.prop === 'sold_to' || atribute.prop === 'ship_to' || atribute.prop === 'ship_to_&_sold_to') && !selectedEntityId && !tableRows.some(r => String(r.po ?? '').trim() !== '' && String(r.value ?? '').trim() === '00000'))}
                      >
                        Upload listed files
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

          </div>
        </Block>
      </Content>
      {/* Modal para editar entidades */}
      <Modal
        show={showEntityModal}
        onHide={closeEntityModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Seleccionar {entityModalType === 'sold_to' ? 'Sold To' : entityModalType === 'ship_to' ? 'Ship To' : 'Ship To & Sold To'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingEntities ? (
            <div className="text-center p-4">
              <div className="spinner-border" role="status">
                <span className="sr-only">Cargando...</span>
              </div>
            </div>
          ) : (
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Seleccionar Entidad</Label>
                  <SimpleAutocomplete
                    name="entity"
                    placeholder="Escriba para buscar..."
                    options={getUniqueEntityOptions().map(opt => opt.name)}
                    value={entityFilter}
                    onChange={(value) => {
                      setEntityFilter(value);
                      const match = getUniqueEntityOptions().find(
                        opt => opt.name.trim().toLowerCase() === value.trim().toLowerCase()
                      );
                      if (match) {
                        handleEntitySelect(match.name);
                      }
                    }}
                  />
                  {selectedEntity && (
                    <small className="text-muted mt-1 d-block">
                      Seleccionado: <strong>{selectedEntity}</strong>
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Seleccionar Dirección</Label>
                  <SimpleAutocomplete
                    name="address"
                    placeholder="Escriba para buscar..."
                    options={getUniqueAddressOptions().map(opt => opt.address || '')}
                    value={addressFilter}
                    onChange={(value) => {
                      setAddressFilter(value);
                      const match = getUniqueAddressOptions().find(
                        opt => opt.address && opt.address.trim().toLowerCase() === value.trim().toLowerCase()
                      );
                      if (match) {
                        setSelectedEntityId(match.id);
                      }
                    }}
                    disabled={!selectedEntity}
                  />
                  {selectedEntityId && (
                    <small className="text-muted mt-1 d-block">
                      ID seleccionado: <strong>{selectedEntityId}</strong>
                    </small>
                  )}
                </FormGroup>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="secondary"
            onClick={closeEntityModal}
          >
            Cerrar
          </Button>
          <Button
            color="primary"
            onClick={saveEntityChanges}
            disabled={!selectedEntity || !selectedEntityId}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const Header = (props) => {
  const {className, onDropAvailable, headerState, item} = props;

  const [{isDragging}, drag] = useDrag(() => ({
    type: headerState,
    item: () => ({...item}),
    end: (data, monitor) => {
      const dropResult = monitor.getDropResult();
      if (data && dropResult) {
        onDropAvailable(data);
      }
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <>
      <li
        className={classnames(
          'list-group-item p-1 border',
          className
        )}
        ref={drag}
        style={{cursor: 'pointer'}}
      >
        <span>
          <GiHamburgerMenu className="mr-2" />
          {item.label}
        </span>
      </li>
    </>
  );
};

// ExcelGrid importado desde src/components/excel/excelGrid.jsx
